export default "__VITE_ASSET__50100f19__"